import { StoreAdminUsersState, AdminUser } from '@/types';

export default {
  adminUsers: (state: StoreAdminUsersState): AdminUser[] => state.adminUsers,
};
